
<clr-progress-bar clrLoop *ngIf="showProgressBar" class="progress-bar"></clr-progress-bar>
<div class="error-section">
  <div *ngIf="showForbiddenError" class="clr-error">
    <p title="Permissions Warning">
      <clr-icon shape="warning-standard"></clr-icon> You do not have enough permissions to continue!
    </p>
  </div>
</div>
<div class="cor-row mv-5">
  <div class="clr-col-11 pl-0">
    <h1 mv-2>Profile Selection</h1>
  </div>
<div class="card" *ngIf="!showForbiddenError || !showProgressBar">
    <div class="clr-col-11 ml-3 mt-3 mb-5">
      <div class="clr-error" *ngIf="errorMessage.length>0">
        <span class="clr-subtext">
          <clr-icon shape="error-standard"></clr-icon> {{errorMessage}}
        </span>
      </div>
      <div class= "mt-3">
        <ng-select id="example" [(ngModel)]="selectedProfileID" class="custom-select w-100"
          (change)="setOrgId($event)" placeholder="Select a value">
          <ng-option *ngFor="let profile of profilesList" [value]="profile.value">
            {{profile.viewValue}}
          </ng-option>
        </ng-select>
        
      </div>
    </div>
  </div>
</div>
<div class="clr-row">
  <div class="clr-col-4">
  <button class="btn btn-primary w-100" id="continue" (click)="selectProfile()">Continue</button>
</div>
</div>

<!-- warning modal: shows when user made changes navigates away  -->
<app-warning-modal
  [warningOpened] = "warningOpened"
  (stay) = "onStay($event);">
</app-warning-modal> 

